import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function queryTitle(){
  return request({
    url:applicationName+'/web/company/title',
    method:'get',
  })
}
export function queryImgs(){
  return request({
    url:applicationName+'/web/company/imgs',
    method:'get',
  })
}
export function queryHistory(){
  return request({
    url:applicationName+'/web/company/history',
    method:'get',
  })
}
export function queryShow(){
  return request({
    url:applicationName+'/web/company/show',
    method:'get',
  })
}
export function queryArea(){
  return request({
    url:applicationName+'/web/company/area',
    method:'get',
  })
}
export function queryShop(data){
  return request({
    url:applicationName+'/web/company/shop',
    method:'get',
    params:data
  })
}